import loadable from "@loadable/component";
import { ConsoleLog, ModalProps } from "@inntechcorp/it-design";
import { GetLocalState } from "Connectivity/LocalStorage";
import ModalRootWrapper from "Modals/index";
import { BOContextPropsType } from "Context/types/BOContextPropsType";
import { CoreConfig } from "Config/CoreConfig";

const AddManualTransaction          = loadable(() => import("Modals/addmanualtransaction/index") as Promise<any>);
const AddGameProviderHighlights     = loadable(() => import("Modals/addgameproviderhighlights/index") as Promise<any>);
const AddGameHighlights             = loadable(() => import("Modals/addgamehighlights/index") as Promise<any>);
const AddNewDomain                  = loadable(() => import("Modals/adddomain/index") as Promise<any>);
const AddGameCategory               = loadable(() => import("Modals/addgamecategory/index") as Promise<any>);
const AddNewRole                    = loadable(() => import("Modals/addnewrole/index") as Promise<any>);
const AddMethodToDepositGroup       = loadable(() => import("Modals/addmethodtodepositgroup/index") as Promise<any>);
const AddNewAdminAccount            = loadable(() => import("Modals/addnewadminaccount/index") as Promise<any>);
const AddNewAffiliateAccount        = loadable(() => import("Modals/addnewaffiliateaccount/index") as Promise<any>);
const AddNewGames                   = loadable(() => import("Modals/addnewgames/index") as Promise<any>);
const EditGame                      = loadable(() => import("Modals/editgame/index") as Promise<any>);
const EditGameCategory              = loadable(() => import("Modals/editgamecategory/index") as Promise<any>);
const EditRole                      = loadable(() => import("Modals/editrole/index") as Promise<any>);
const EditGameProvider              = loadable(() => import("Modals/editgameprovider/index") as Promise<any>);
const SetBank                       = loadable(() => import("Modals/setbank/index") as Promise<any>);
const SetBankAccount                = loadable(() => import("Modals/setbankaccount/index") as Promise<any>);
const SetDepositGroup               = loadable(() => import("Modals/setdepositgroup/index") as Promise<any>);
const SetPaymentType                = loadable(() => import("Modals/setpaymenttype/index") as Promise<any>);
const SetPaymentMethod              = loadable(() => import("Modals/setpaymentmethod/index") as Promise<any>);
const SetUserBetLimit               = loadable(() => import("Modals/setuserbetlimit/index") as Promise<any>);
const SetSlider                     = loadable(() => import("Modals/setslider/index") as Promise<any>);
const SetPromotionCategory          = loadable(() => import("Modals/setpromotioncategory/index") as Promise<any>);
const SetPage                       = loadable(() => import("Modals/setpage/index") as Promise<any>);
const SetSitemapGroup               = loadable(() => import("Modals/setsitemapgroup/index") as Promise<any>);
const SetSitemapItem                = loadable(() => import("Modals/setsitemapitem/index") as Promise<any>);
const SetHeaderMenu                 = loadable(() => import("Modals/setheadermenu/index") as Promise<any>);
const SetHeaderMenuItem             = loadable(() => import("Modals/setheadermenuitem/index") as Promise<any>);
const SetAuthenticationMethod       = loadable(() => import("Modals/setauthenticationmethod/index") as Promise<any>);
const SetProfileMenu                = loadable(() => import("Modals/setprofilemenu/index") as Promise<any>);
const SetMobileMenu                 = loadable(() => import("Modals/setmobilemenu/index") as Promise<any>);
const SetMobileMegaMenu             = loadable(() => import("Modals/setmobilemegamenu/index") as Promise<any>);
const SetMobileMegaMenuItem         = loadable(() => import("Modals/setmobilemegamenuitem/index") as Promise<any>);
const SetFreeSpinCampaign           = loadable(() => import("Modals/setfreespincampaign/index") as Promise<any>);
const SetUserLabels                 = loadable(() => import("Modals/setuserlabels/index") as Promise<any>);
const SetUserNote                   = loadable(() => import("Modals/setusernote/index") as Promise<any>);
const SetAffiliateNote              = loadable(() => import("Modals/setaffiliatenote/index") as Promise<any>);
const SetUserDeclineNote            = loadable(() => import("Modals/setuserdeclinenote/index") as Promise<any>);
const SetStaticPageGroup            = loadable(() => import("Modals/setstaticpagegroup/index") as Promise<any>);
const SetGameBonusLimit             = loadable(() => import("Modals/setgamebonuslimit/index") as Promise<any>);
const PreviewWithdrawAccount        = loadable(() => import("Modals/previewwithdrawaccount/index") as Promise<any>);
const EditWithdrawAccount           = loadable(() => import("Modals/editwithdrawaccount/index") as Promise<any>);
const AssignWithdrawTransaction     = loadable(() => import("Modals/assignwithdrawtransaction/index") as Promise<any>);
const ActivateBonus                 = loadable(() => import("Modals/activatebonusrequest/index") as Promise<any>);
const ActivateNewDomain             = loadable(() => import("Modals/activatedomain/index") as Promise<any>);
const Disconnect                    = loadable(() => import("Modals/disconnect/index") as Promise<any>);
const CreateSupportTicket           = loadable(() => import("Modals/createsupportticket/index") as Promise<any>);
const DeclineBonus                  = loadable(() => import("Modals/declinebonusrequest/index") as Promise<any>);
const CheckBonus                    = loadable(() => import("Modals/checkbonus/index") as Promise<any>);
const ShowTransaction               = loadable(() => import("Modals/showtransaction/index") as Promise<any>);
const ShowRoutes                    = loadable(() => import("Modals/showroutes/index") as Promise<any>);
const UpdateDepositRequest          = loadable(() => import("Modals/updatedepositrequest/index") as Promise<any>);
const SuspendWithdrawTransaction    = loadable(() => import("Modals/suspendwithdrawtransaction/index") as Promise<any>);
const TransferBonus                 = loadable(() => import("Modals/transferbonus/index") as Promise<any>);
const ChangeAdminAccountRole        = loadable(() => import("Modals/changeadminaccountrole/index") as Promise<any>);
const TransactionTerminationPhase   = loadable(() => import("Modals/transactionterminationphase/index") as Promise<any>);
const MarkAsSuspiciousTransaction   = loadable(() => import("Modals/markassuspicioustransaction/index") as Promise<any>);
const FreeSpinCampaignDetail        = loadable(() => import("Modals/freespincampaigndetail/index") as Promise<any>);
const RaffleDetail                  = loadable(() => import("Modals/raffledetail/index") as Promise<any>);
const TournamentEditBase            = loadable(() => import("Modals/tournamenteditbase/index") as Promise<any>);
const TournamentEditSettings        = loadable(() => import("Modals/tournamenteditsettings/index") as Promise<any>);
const TournamentRegenerateImages    = loadable(() => import("Modals/tournamentregenerateimages/index") as Promise<any>);
const TournamentPublishWinners      = loadable(() => import("Modals/tournamentpublishwinners/index") as Promise<any>);
const TournamentCancel              = loadable(() => import("Modals/tournamentcancel/index") as Promise<any>);
const TournamentWinnerDelivery      = loadable(() => import("Modals/tournamentwinnerdelivery/index") as Promise<any>);
const TournamentParticipantBets     = loadable(() => import("Modals/tournamentparticipantbets/index") as Promise<any>);
const CancelFreeSpin                = loadable(() => import("Modals/cancelfreespin/index") as Promise<any>);
const CancelBonus                   = loadable(() => import("Modals/cancelbonus/index") as Promise<any>);
const TransferFreeSpin              = loadable(() => import("Modals/transferfreespin/index") as Promise<any>);
const ExportData                    = loadable(() => import("Modals/exportdata/index") as Promise<any>);
const UsedByModal                   = loadable(() => import("Modals/usedby/index") as Promise<any>);
const UserRaffleTickets             = loadable(() => import("Modals/userraffletickets/index") as Promise<any>);
const UserWinningTickets            = loadable(() => import("Modals/userwinningtickets/index") as Promise<any>);

const getModalByName = (name:string) => {

  if ( name === "disconnect" )                    return Disconnect;
  if ( name === "createSupportTicket" )           return CreateSupportTicket;
  if ( name === "editGameProvider" )              return EditGameProvider;
  if ( name === "editGame" )                      return EditGame;
  if ( name === "editGameCategory" )              return EditGameCategory;
  if ( name === "addGameCategory" )               return AddGameCategory;
  if ( name === "addNewRole" )                    return AddNewRole;
  if ( name === "editRole" )                      return EditRole;
  if ( name === "activateBonus" )                 return ActivateBonus;
  if ( name === "addMethodToDepositGroup" )       return AddMethodToDepositGroup;
  if ( name === "assignWithdrawTransaction" )     return AssignWithdrawTransaction;
  if ( name === "declineBonus" )                  return DeclineBonus;
  if ( name === "checkBonus" )                    return CheckBonus;
  if ( name === "showTransaction" )               return ShowTransaction;
  if ( name === "previewWithdrawAccount" )        return PreviewWithdrawAccount;
  if ( name === "editWithdrawAccount" )          return EditWithdrawAccount;
  if ( name === "updateDepositRequest" )          return UpdateDepositRequest;
  if ( name === "suspendWithdrawTransaction" )    return SuspendWithdrawTransaction;
  if ( name === "addManualTransaction" )          return AddManualTransaction;
  if ( name === "transferBonus" )                 return TransferBonus;
  if ( name === "setUserBetLimit" )               return SetUserBetLimit;
  if ( name === "addGameProviderHighlights" )     return AddGameProviderHighlights;
  if ( name === "addGameHighlights" )             return AddGameHighlights;
  if ( name === "addDomain" )                     return AddNewDomain;
  if ( name === "activateDomain" )                return ActivateNewDomain;
  if ( name === "setSlider" )                     return SetSlider;
  if ( name === "setStaticPageGroup" )            return SetStaticPageGroup;
  if ( name === "setPromotionCategory" )          return SetPromotionCategory;
  if ( name === "setPage" )                       return SetPage;
  if ( name === "setSitemapGroup" )               return SetSitemapGroup;
  if ( name === "setSitemapItem" )                return SetSitemapItem;
  if ( name === "setHeaderMenu" )                 return SetHeaderMenu;
  if ( name === "setHeaderMenuItem" )             return SetHeaderMenuItem;
  if ( name === "showRoutes" )                    return ShowRoutes;
  if ( name === "changeAdminAccountRole" )        return ChangeAdminAccountRole;
  if ( name === "setAuthenticationMethod" )       return SetAuthenticationMethod;
  if ( name === "addNewAdminAccount" )            return AddNewAdminAccount;
  if ( name === "addNewAffiliateAccount" )        return AddNewAffiliateAccount;
  if ( name === "setProfileMenu" )                return SetProfileMenu;
  if ( name === "setMobileMenu" )                 return SetMobileMenu;
  if ( name === "setMobileMegaMenu" )             return SetMobileMegaMenu;
  if ( name === "setMobileMegaMenuItem" )         return SetMobileMegaMenuItem;
  if ( name === "addNewGames" )                   return AddNewGames;
  if ( name === "setBank" )                       return SetBank;
  if ( name === "setBankAccount" )                return SetBankAccount;
  if ( name === "setDepositGroup" )               return SetDepositGroup;
  if ( name === "setPaymentType" )                return SetPaymentType;
  if ( name === "setPaymentMethod" )              return SetPaymentMethod;
  if ( name === "transactionTerminationPhase" )   return TransactionTerminationPhase;
  if ( name === "setGameBonusLimit" )             return SetGameBonusLimit;
  if ( name === "setFreeSpinCampaign" )           return SetFreeSpinCampaign;
  if ( name === "freeSpinCampaignDetail" )        return FreeSpinCampaignDetail;
  if ( name === "raffleDetail" )                  return RaffleDetail;
  if ( name === "tournamentEditBase" )            return TournamentEditBase;
  if ( name === "tournamentEditSettings" )        return TournamentEditSettings;
  if ( name === "tournamentRegenerateImages" )    return TournamentRegenerateImages;
  if ( name === "tournamentPublishWinners" )      return TournamentPublishWinners;
  if ( name === "tournamentCancel" )              return TournamentCancel;
  if ( name === "tournamentWinnerDelivery" )      return TournamentWinnerDelivery;
  if ( name === "tournamentParticipantBets" )     return TournamentParticipantBets;
  if ( name === "transferFreeSpin" )              return TransferFreeSpin;
  if ( name === "cancelFreeSpin" )                return CancelFreeSpin;
  if ( name === "cancelBonus" )                   return CancelBonus;
  if ( name === "markAsSuspiciousTransaction" )   return MarkAsSuspiciousTransaction;
  if ( name === "setUserLabels" )                 return SetUserLabels;
  if ( name === "setUserNote" )                   return SetUserNote;
  if ( name === "setAffiliateNote" )              return SetAffiliateNote;
  if ( name === "setUserDeclineNote" )            return SetUserDeclineNote;
  if ( name === "usedByModal" )                   return UsedByModal;
  if ( name === "exportData" )                    return ExportData;
  if ( name === "userRaffleTickets" )             return UserRaffleTickets;
  if ( name === "userWinningTickets" )            return UserWinningTickets;
  
  return null;

}

/**
 * 
 * Modal sınıfı `ITDContext` içerisindeki `ModalManager` ile rahatlıkla açılabilir
 * fakat bu fonksiyon açılacak modal'ı config dosyasındaki değerlere göre kontrol
 * eder ve modal'ı bulursa modal'ın açılması için gerekli olan objeyi oluşturur.
 * 
 * Modal yüklendikten sonra `Content` değişkenini kullanmak için `React.cloneElement`
 * fonksiyonu kullanılmalıdır.
 * 
 * Ayrıca modal'lar `WebContext` sınıfına `React.Portal` üzerinde olduklarından 
 * ulaşamazlar. Eğer açılacak modal bir login dönüşüne sahipse `WebContext` sınıfı
 * `changeLogin` fonksiyonunu modal'ın prop'una tanımlar. Böylece kullanıcı login
 * veya kayıt olunca `changeLogin` fonksiyonunu çağırabilir olur.
 * 
 * @param {*} name Açılacak modal'ın ismi. Bu isim config'te tanımlanmış
 *            modalları bulmak için kullanılır.
 * @param {*} data Modal'ın props'u. Açılacak modal hazır bir içeriğe sahip
 *            değilse (örnek promosyon detay) bu bilgi buradan istenilen
 *            şekilde geçilebilir.
 * @param {*} changeLogin WebContext sınıfınının login olan kullanıcının
 *            bilgisini kayıt eden fonksiyon. 
 * 
 * @returns Modal'ın açılması için hazırlanmış objeyi döndürür.
 * 
 */
const ModalData = (
  name          : string,
  data          : ModalProps,
  context       : BOContextPropsType
) => {

  // Config'ten gelen modal dataları.
  const modals = GetLocalState("modals");

  if ( !modals ) {
    ConsoleLog.double(`🔴 ${CoreConfig.BackOfficeName} Back Office Error [Modal Data]`, "Can't find the modals session state!", "error");
    return;
  }

  if ( modals.hasOwnProperty(name) ) {
  
    // for mobile
    if ( !data.hasOwnProperty("outerPadding") ) {
      data.outerPadding = "50px 0";
    }

    // Modal dışında tıklanıldığında kapatılır olup
    // olmadığını belirler.
    if ( modals[name].hasOwnProperty("closeOnClickOutside") ) {
      data.closeOnClickOutside = modals[name].closeOnClickOutside;
    }
    
    // Disconnect modalı gibi ESC tuşu ile bile kapanmaması
    // gereken sabit modallar için ESC tuşu ile kapatmayı
    // iptal etme.
    if ( modals[name].hasOwnProperty("preventESC") ) {
      data.preventESC = modals[name].preventESC;
    }

    // Modal'da OK tuşunu göstermez.
    if ( modals[name].hasOwnProperty("showOkButton") ) {
      data.showOkButton = modals[name].showOkButton;
    }

    // Modal'da Cancel tuşunu göstermez.
    if ( modals[name].hasOwnProperty("showCancelButton") ) {
      data.showCancelButton = modals[name].showCancelButton;
    }

    // Modal'da kapat tuşunu göstermez.
    if ( modals[name].hasOwnProperty("showCloseButton") ) {
      data.showCloseButton = modals[name].showCloseButton;
    }

    // 
    if ( modals[name].hasOwnProperty("useRef") ) {
      data.useRef = modals[name].useRef;
    }

    // Bazı modal'lar extra custom proplara ihtiyaç duyabiliyor.
    // Misal Reset Password'ün input göstermesi veya Canlı Destek'e
    // bağlan demesi gibi custom propları ekler.
    if ( modals[name].hasOwnProperty("props") ) {
      data.customProps = {
        ...data.customProps,
        ...modals[name].props
      }
    }

    /**
     * ModalManager sınıfı içerisinde React'in ulaşamadığı
     * Portal'a bilgi geçmek için kullanılan context yapısı bulunur.
     * Buraya kendi context bilgilerimizi ulaşabilmek için iletiriz.
     */
    data.context = context;

    // Yüklenecek modal block'unun adresi.
    if ( !data.content ) {
      
      const modal = getModalByName(name);
      
      if ( !modal ) {
        throw new Error("INN Modal Error: There is no modal registered with this name '" + name + "'");
      }

      data.customProps = {
        ...data.customProps,
        modal         : modal
      }

      data.content = (
        <ModalRootWrapper />
      )

    }

  }
  else {
    ConsoleLog.double(`🔴 ${CoreConfig.BackOfficeName} Back Office Error [Modal Data]`, "Can't find the modal in modals array, name: " + name, "error");
    return;
  }
  
  return data;

}

export default ModalData;